import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { useRecoilValue } from 'recoil';
import { departmentAtom, storeAtom } from '../../../../atoms/Atoms';

function Breadcrumb() {
  const { t } = useTranslation();
  const store = useRecoilValue(storeAtom);
  const department = useRecoilValue(departmentAtom);

  return (
    <div className="container mx-auto flex flex-shrink-0 items-center w-full text-xs tracking-tight p-4 space-x-1 truncate">
      <NavLink
        to="/"
        className="hover:text-emerald-500 transition duration-500 ease-in-out"
      >
        {t('home')}
      </NavLink>
      <FontAwesomeIcon icon={faChevronRight} />
      <NavLink
        to={`/stores/${store && store.id}`}
        className="hover:text-emerald-500 transition duration-500 ease-in-out"
      >
        {store && store.name}
      </NavLink>
      <FontAwesomeIcon icon={faChevronRight} />
      <NavLink
        to={`/stores/${store && store.id}/departments`}
        className="hover:text-emerald-500 transition duration-500 ease-in-out"
      >
        {t('departments')}
      </NavLink>
      {department && (
        <>
          <FontAwesomeIcon icon={faChevronRight} />
          <div className="text-gray-400">{department && department.name}</div>
        </>
      )}
    </div>
  );
}

export default Breadcrumb;
